import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from 'src/utils/api';
import { ShoppingCartActionTypes as act } from './actionTypes';
export const getRecurringStartDate = (startData) => {
  return () => {
    const action = createAction(act.GET_RECURRING_START_DATE_DATA)(
      callApi(getEndpoint('recurringStartDate'), { method: 'POST' }, startData)
    );
    return action;
  };
};
